import useLinks from "~/ui/useLinks";
import { DesktopNavigationBar } from "./DesktopNavigationBar";
import { MobileNavigationBar } from "./MobileNavigationBar";
import type { NavigationBarProps } from "./NavigationBarProps";

type RootNavigationBarProps = Partial<NavigationBarProps>;

export default function NavigationBar(props: RootNavigationBarProps) {
  const defaultLinks = useLinks();
  const links = props.links ?? defaultLinks;
  return (
    <div>
      <DesktopNavigationBar links={links} />
      <MobileNavigationBar links={links} />
    </div>
  );
}
